import React from "react";
import { ICON_PATHS } from "./tagIconPaths";

// Curated icon set for order tags. Feather-style stroke icons (24x24,
// stroke="currentColor") to match the inline SVGs used across Chariot — no icon
// library dependency. Each tag stores just the KEY (e.g. "anchor"); render with
// <TagIcon name="anchor" />. Add new icons by appending to ICON_PATHS + TAG_ICONS.

// Icons grouped into categories for the picker, with similar items together.
// Order is intentional (not alphabetical) — keep related icons adjacent.
export const ICON_CATEGORIES = [
  {
    category: "Vessels",
    icons: [
      { key: "boat", label: "Boat" },
      { key: "jetski", label: "Jet Ski" },
      { key: "barge", label: "Barge" },
      { key: "anchor", label: "Anchor" },
      { key: "compass", label: "Compass" },
      { key: "lifebuoy", label: "Life Buoy" },
    ],
  },
  {
    category: "Engine & Fuel",
    icons: [
      { key: "inboard", label: "Inboard Motor" },
      { key: "outboard", label: "Outboard Motor" },
      { key: "propeller", label: "Propeller" },
      { key: "diesel", label: "Diesel" },
      { key: "fuel", label: "Fuel / Gas" },
      { key: "helm", label: "Steering / Helm" },
    ],
  },
  {
    category: "Service & Repair",
    icons: [
      { key: "wrench", label: "Wrench" },
      { key: "detailing", label: "Detailing" },
      { key: "fiberglass", label: "Fiberglass" },
      { key: "bottompaint", label: "Bottom Paint" },
      { key: "welding", label: "Welding" },
      { key: "plug", label: "Electrical" },
      { key: "battery", label: "Battery" },
      { key: "snowflake", label: "Winterize" },
      { key: "computer", label: "Diagnostic" },
      { key: "gauge", label: "Gauge" },
      { key: "thermometer", label: "Temperature" },
      { key: "droplet", label: "Water" },
      { key: "package", label: "Parts" },
      { key: "clipboard", label: "Inspection" },
    ],
  },
  {
    category: "Transport & Places",
    icons: [
      { key: "trailer", label: "Boat Trailer" },
      { key: "boatlift", label: "Boat Lift" },
      { key: "crane", label: "Crane" },
      { key: "tow", label: "Tow / Haul-Out" },
      { key: "truck", label: "Delivery" },
      { key: "route", label: "Route" },
      { key: "dock", label: "Dock / Slip" },
      { key: "house", label: "On-Site" },
      { key: "shop", label: "Shop / Garage" },
      { key: "pin", label: "Location" },
    ],
  },
  {
    category: "Scheduling",
    icons: [
      { key: "calendar", label: "Calendar" },
      { key: "clock", label: "Clock" },
      { key: "lockschedule", label: "Do Not Move" },
      { key: "hourglass", label: "Waiting" },
      { key: "refresh", label: "Recurring" },
      { key: "bell", label: "Reminder" },
    ],
  },
  {
    category: "Status & Priority",
    icons: [
      { key: "check", label: "Check" },
      { key: "x", label: "Cancel" },
      { key: "thumbsup", label: "Approved" },
      { key: "thumbsdown", label: "Thumbs Down" },
      { key: "alert", label: "Alert" },
      { key: "emergency", label: "Emergency" },
      { key: "flame", label: "Hot" },
      { key: "zap", label: "Priority" },
      { key: "exclamation", label: "Important" },
      { key: "question", label: "Question" },
      { key: "lock", label: "Hold" },
      { key: "shield", label: "Warranty" },
      { key: "flag", label: "Flag" },
      { key: "star", label: "Star" },
      { key: "bookmark", label: "Bookmark" },
      { key: "heart", label: "Favorite" },
    ],
  },
  {
    category: "People & Billing",
    icons: [
      { key: "user", label: "Customer" },
      { key: "users", label: "Team" },
      { key: "phone", label: "Phone" },
      { key: "mail", label: "Email" },
      { key: "message", label: "Message" },
      { key: "dollar", label: "Dollar" },
      { key: "card", label: "Card" },
      { key: "cash", label: "Cash / Paid" },
      { key: "document", label: "Invoice / Quote" },
      { key: "signature", label: "Signature" },
    ],
  },
  {
    category: "Safety & Other",
    icons: [
      { key: "camera", label: "Photo" },
      { key: "key", label: "Key" },
      { key: "gear", label: "Settings" },
      { key: "info", label: "Info" },
      { key: "archive", label: "Archive" },
    ],
  },
];

// Flat list of every icon (derived) — handy for lookups/validation.
export const TAG_ICONS = ICON_CATEGORIES.flatMap((c) => c.icons);

export function TagIcon({ name, size = 16, className, strokeWidth = 2 }) {
  const content = name ? ICON_PATHS[name] : null;
  if (!content) return null;
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {content}
    </svg>
  );
}
